import { Injectable } from "@angular/core";
import { RestReadServiceBase } from "@definitiv-packages/angular-dba-library";
import { ServiceModelView } from "../../types/ServiceModel";

@Injectable({
    providedIn: 'root'
})
export class ServiceViewService extends RestReadServiceBase<ServiceModelView> {
    constructor(
    ) {
        super("ServiceModelView", false);
    }

 
}